import { taskApi as api } from './api';
import axios from 'axios';

export interface TaskType {
  id: string;
  name: string;
  code: string;
}

export interface TaskTypesResponse {
  taskTypes: TaskType[];
}

export const fetchTaskTypeList = async () => {
  const url = `/v2/task-types`;
  const response = await api.get<TaskTypesResponse>(url);
  if (axios.isAxiosError(response)) {
    throw response;
  }
  return response.data;
};

interface TaskTypeV3Resource {
  id: string;
  type: 'task-types';
  attributes: { name: string; code: string; isSystem: boolean };
}

export const fetchTaskTypeListV3 = async (): Promise<TaskTypesResponse> => {
  const url = `/v3/task-types`;
  const response = await api.get<{ data: TaskTypeV3Resource[] }>(url);
  if (axios.isAxiosError(response)) {
    throw response;
  }
  return {
    taskTypes: response.data.data.map((resource) => ({
      id: resource.id,
      name: resource.attributes.name,
      code: resource.attributes.code,
    })),
  };
};
